<div class="month-period-field" [attr.data-id]="field.key">
  <rdr-svg-icon
    class="cursor-pointer"
    key="chevron-left"
    size="lg"
    data-id="prev-period"
    (click)="prev()"
  ></rdr-svg-icon>

  <button
    type="button"
    class="month-period-field__trigger"
    data-id="period-picker-trigger"
    (click)="togglePicker($event)"
  >
    <typography-v2 class="month-period-field__label">{{ label }}</typography-v2>
    <rdr-svg-icon
      [ngClass]="{ 'month-period-field__chevron--open': pickerOpen }"
      class="month-period-field__chevron"
      color="var(--color-black-50)"
      key="chevron-bottom"
      size="sm"
    ></rdr-svg-icon>
  </button>

  <rdr-svg-icon
    [ngClass]="canGoNext ? 'cursor-pointer' : 'month-period-field__nav--disabled'"
    key="chevron-right"
    size="lg"
    data-id="next-period"
    (click)="next()"
  ></rdr-svg-icon>

  <div
    *ngIf="pickerOpen"
    class="month-period-field__picker"
    data-id="period-picker"
    (click)="$event.stopPropagation()"
  >
    <div class="month-period-field__selectors">
      <dropdown-v2
        class="month-period-field__month"
        data-id="period-month"
        [items]="monthItems"
        [selectedItem]="selectedMonth"
        placeholder="Month"
        (itemSelect)="onMonthSelect($event)"
      ></dropdown-v2>
      <dropdown-v2
        class="month-period-field__year"
        data-id="period-year"
        [items]="yearItems"
        [selectedItem]="selectedYear"
        placeholder="Year"
        (itemSelect)="onYearSelect($event)"
      ></dropdown-v2>
    </div>

    <button-v2
      type="tertiary"
      look="link"
      data-id="current-period"
      [disabled]="isCurrent || !currentPeriod"
      (click)="goToCurrent()"
    >
      Current
    </button-v2>
  </div>
</div>
